//import {Container, Col, Row }from 'react-bootstrap';

function ContentBDEFoundingText(){
    return (
        <> 
            <p className="py-0 text-start font-body color-font-primary font-size-large">Making it official</p>

            <p className="py-0 text-start font-body color-font-primary font-size-small">Big Distance Energy is an independent crafts studio that uses various skills in digital and print media as well as textiles to create marketing strategies and consumer experiences that tell stories. Our partners work collaboratively or independently to craft unique works that provoke thought and emotion.</p>

            <p className="py-0 text-start font-body color-font-primary font-size-small">Big Distance Energy was founded during 2024, in Dallas, Texas. The studio was designed to be a vehicle within the confines of endurance sport to polish and present remarkable people, events, and organizations whose work would go unnoticed because there was not a more enticing presentation to shepherd it into more mainstreams.</p>
        </>
    )
}

export default ContentBDEFoundingText;